import { Component, ViewChild } from '@angular/core';
import { NavController, Nav, Events } from 'ionic-angular';

// Pages
import { DashboardPage } from '../../pages/dashboard/dashboard';

// Providers
import { LoginService } from '../../providers/login/login-service';
import { Config } from '../../providers/config/config';
import { HelperService } from '../../providers/helpers/helper-service';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  headerData: any;
  login: any = {};
  errorMessage: string = '';
  showLogin: boolean = true;
  showForgotPassword: boolean = false;

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public loginService: LoginService,
    public helperService: HelperService
  ) {
    this.headerData = { title: 'ODOT Certification System' };
  }

  submitLoginForm()
  {
    // Send to service
    this.loginService.login( this.login )
      .subscribe( data => {
        // Not sure why I have to do this here :-\
        // Don't think I've ever had to do this before.
        // Needed it to keep TS from bitching about access_token not
        // existing on type Object.
        let d:any = data;
        Config.ACCESS_TOKEN = d.access_token;
        Config.USER = d.user;

        // Set local storage data
        localStorage.setItem('access_token', d.access_token); 
        localStorage.setItem('user', JSON.stringify( d.user ));
        this.events.publish( 'user:login' );
        this.navCtrl.setRoot( DashboardPage );
      },
      error => {
        this.helperService.showErrors( error );
      } 
      
    );
  }

  showForgotPasswordForm()
  {
    this.showLogin = false;
    this.showForgotPassword = true;
  }

  showLoginForm()
  {
    this.showLogin = true;
    this.showForgotPassword = false;
  }
}  


// WEBPACK FOOTER //
// ./src/pages/login/login.ts